import TopBar from '@/pages/home/components/TopBar';
import Hero from '@/pages/home/components/Hero';
import StatusStrip from '@/pages/home/components/StatusStrip';
import AddressList from '@/pages/home/components/AddressList';
import AppDownload from '@/pages/home/components/AppDownload';
import TrendingList from '@/pages/home/components/TrendingList';
import CommentsSection from '@/pages/home/components/CommentsSection';
import GuideFaq from '@/pages/home/components/GuideFaq';
import SiteFooter from '@/pages/home/components/SiteFooter';

export default function Home() {
  return (
    <div className="min-h-screen w-full overflow-x-hidden bg-background-50 font-body text-foreground-900">
      <TopBar />
      <main>
        <Hero />
        <StatusStrip />
        <AddressList />
        <AppDownload />
        <TrendingList />
        <CommentsSection />
        <GuideFaq />
      </main>
      <SiteFooter />
    </div>
  );
}